/**
 * @flow
 * @relayHash 9f090ff6df8bbb63110f78c3ca07c137
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type BrokerActivityTransactionPerformanceType = {|
  brokerActivityTransactionId: string,
  portfolioId: string,
  contractId: string,
  currency: Currency,
  price?: ?any,
  quantity?: ?any,
  costBasis?: ?any,
  sequence?: ?number,
  commission?: ?any,
  splitFactor?: ?any,
  splitResult?: ?any,
  oldContractId?: ?string,
  newContractId?: ?string,
  spinoffContractId?: ?string,
  dummied?: ?boolean,
|};
export type UpdateBrokerActivityPerformanceMutationVariables = {|
  brokerActivityGroupId: string,
  entries: $ReadOnlyArray<?BrokerActivityTransactionPerformanceType>,
|};
export type UpdateBrokerActivityPerformanceMutationResponse = {|
  +updateBrokerActivityPerformance: ?{|
    +brokerActivities: ?$ReadOnlyArray<?{|
      +brokeractivitytransactionSet: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +brokeractivitytransactionperformanceSet: {|
              +edges: $ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +sequence: number,
                  +portfolio: {|
                    +id: string,
                    +trackingVueName: ?string,
                  |},
                  +contract: {|
                    +id: string,
                    +symbol: string,
                  |},
                  +costBasis: ?number,
                  +commission: number,
                  +updatedAt: any,
                  +currency: Currency,
                  +price: number,
                  +quantity: number,
                  +splitFactor: ?number,
                  +splitResult: ?number,
                  +oldContract: ?{|
                    +id: string,
                    +symbol: string,
                  |},
                  +newContract: ?{|
                    +id: string,
                    +symbol: string,
                  |},
                  +spinoffContract: ?{|
                    +id: string,
                    +symbol: string,
                  |},
                  +dummied: boolean,
                |}
              |}>
            |}
          |}
        |}>
      |}
    |}>
  |}
|};
export type UpdateBrokerActivityPerformanceMutation = {|
  variables: UpdateBrokerActivityPerformanceMutationVariables,
  response: UpdateBrokerActivityPerformanceMutationResponse,
|};
*/


/*
mutation UpdateBrokerActivityPerformanceMutation(
  $brokerActivityGroupId: ID!
  $entries: [BrokerActivityTransactionPerformanceType]!
) {
  updateBrokerActivityPerformance(brokerActivityGroupId: $brokerActivityGroupId, entries: $entries) {
    brokerActivities {
      brokeractivitytransactionSet {
        edges {
          node {
            brokeractivitytransactionperformanceSet {
              edges {
                node {
                  id
                  sequence
                  portfolio {
                    id
                    trackingVueName
                  }
                  contract {
                    id
                    symbol
                  }
                  costBasis
                  commission
                  updatedAt
                  currency
                  price
                  quantity
                  splitFactor
                  splitResult
                  oldContract {
                    id
                    symbol
                  }
                  newContract {
                    id
                    symbol
                  }
                  spinoffContract {
                    id
                    symbol
                  }
                  dummied
                }
              }
            }
            id
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "brokerActivityGroupId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "entries",
    "type": "[BrokerActivityTransactionPerformanceType]!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brokerActivityGroupId",
    "variableName": "brokerActivityGroupId"
  },
  {
    "kind": "Variable",
    "name": "entries",
    "variableName": "entries"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "symbol",
    "args": null,
    "storageKey": null
  }
],
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactionperformanceSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionPerformanceNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionPerformanceNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionPerformanceNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "sequence",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "portfolio",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfolioNode",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "trackingVueName",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "contract",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractNode",
              "plural": false,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "costBasis",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "commission",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "updatedAt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "currency",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "quantity",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "splitFactor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "splitResult",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "oldContract",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractNode",
              "plural": false,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "newContract",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractNode",
              "plural": false,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "spinoffContract",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractNode",
              "plural": false,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "dummied",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateBrokerActivityPerformanceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateBrokerActivityPerformance",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBrokerActivityPerformance",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivities",
            "storageKey": null,
            "args": null,
            "concreteType": "BrokerActivityNode",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brokeractivitytransactionSet",
                "storageKey": null,
                "args": null,
                "concreteType": "BrokerActivityTransactionNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityTransactionNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityTransactionNode",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateBrokerActivityPerformanceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateBrokerActivityPerformance",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBrokerActivityPerformance",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivities",
            "storageKey": null,
            "args": null,
            "concreteType": "BrokerActivityNode",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brokeractivitytransactionSet",
                "storageKey": null,
                "args": null,
                "concreteType": "BrokerActivityTransactionNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityTransactionNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityTransactionNode",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateBrokerActivityPerformanceMutation",
    "id": null,
    "text": "mutation UpdateBrokerActivityPerformanceMutation(\n  $brokerActivityGroupId: ID!\n  $entries: [BrokerActivityTransactionPerformanceType]!\n) {\n  updateBrokerActivityPerformance(brokerActivityGroupId: $brokerActivityGroupId, entries: $entries) {\n    brokerActivities {\n      brokeractivitytransactionSet {\n        edges {\n          node {\n            brokeractivitytransactionperformanceSet {\n              edges {\n                node {\n                  id\n                  sequence\n                  portfolio {\n                    id\n                    trackingVueName\n                  }\n                  contract {\n                    id\n                    symbol\n                  }\n                  costBasis\n                  commission\n                  updatedAt\n                  currency\n                  price\n                  quantity\n                  splitFactor\n                  splitResult\n                  oldContract {\n                    id\n                    symbol\n                  }\n                  newContract {\n                    id\n                    symbol\n                  }\n                  spinoffContract {\n                    id\n                    symbol\n                  }\n                  dummied\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '949d8c252198f4c6ee928093930971e2';
module.exports = node;
